import { render, staticRenderFns } from "./OnboardingImportAdvancedMethodModal.vue?vue&type=template&id=4254414a&scoped=true"
import script from "./OnboardingImportAdvancedMethodModal.vue?vue&type=script&lang=js"
export * from "./OnboardingImportAdvancedMethodModal.vue?vue&type=script&lang=js"
import style0 from "./OnboardingImportAdvancedMethodModal.vue?vue&type=style&index=0&id=4254414a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4254414a",
  null
  
)

export default component.exports